import { SoccerStages } from '@adflow/types';

const SOCCER_COMMON_SOURCE_TYPE = 'SOCCER';

const STAGE_SOURCE_TYPE_TO_STAGE: Record<string, SoccerStages> = {
  SOCCER_PRE: SoccerStages.PRE_EVENT,
  SOCCER_LIVE: SoccerStages.LIVE,
  SOCCER_LIVE_GOAL: SoccerStages.LIVE_GOAL,
  SOCCER_POST: SoccerStages.POST_EVENT,
  SOCCER_POST_WINNER: SoccerStages.POST_WINNER,
};

type DataSourceLite = { id: string; type: string };

export type SoccerPreviewQualification =
  | { kind: 'not-soccer' }
  | { kind: 'invalid'; reason: 'no-stage' | 'multiple-stages' }
  | { kind: 'valid'; stage: SoccerStages };

export const resolveStage = (
  dataSources: ReadonlyArray<DataSourceLite> | undefined,
): SoccerPreviewQualification => {
  if (!dataSources || dataSources.length === 0) {
    return { kind: 'not-soccer' };
  }

  const hasSoccerCommonSource = dataSources.some(
    (dataSource) => dataSource.type === SOCCER_COMMON_SOURCE_TYPE,
  );
  if (!hasSoccerCommonSource) {
    return { kind: 'not-soccer' };
  }

  const matchedStages = new Set<SoccerStages>();
  for (const dataSource of dataSources) {
    const stage = STAGE_SOURCE_TYPE_TO_STAGE[dataSource.type];
    if (stage !== undefined) {
      matchedStages.add(stage);
    }
  }

  if (matchedStages.size === 0) {
    return { kind: 'invalid', reason: 'no-stage' };
  }

  if (matchedStages.size > 1) {
    return { kind: 'invalid', reason: 'multiple-stages' };
  }

  const [stage] = matchedStages;
  return { kind: 'valid', stage };
};
